module.exports = __webpack_public_path__ + "img/entry1.2ca0f2cb.jpg";